import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { filter, first, map, startWith } from 'rxjs/operators';

@UntilDestroy()
@Injectable({
	providedIn: 'root',
})
export class UrlHistoryService {
	private _lastUrlCount = -1;
	private _history: { [id: string]: string } = {};
	private _lastUrl: string;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private store: Store,
	) {
		this.router.events
			.pipe(
				untilDestroyed(this),
				filter((e) => e instanceof NavigationEnd),
				startWith(this.router),
				map(() => this.router.url),
				map(() => this.activatedRoute),
				map((route) => {
					let _route = route;
					let _saveUrl;

					let completeUrl = '';

					while (_route) {
						_route.url
							.pipe(
								first(),
								map((x) =>
									x.filter((y) => y.path !== undefined && y.path.length > 0),
								),
							)
							.subscribe((_url) => {
								if (_url.length > 0) {
									completeUrl += `/${_url.join('/')}`;
								}

								if (_route.snapshot?.data?.addToHistory) {
									_saveUrl = completeUrl;
								}

								_route = _route.firstChild;
							});
					}

					return _saveUrl;
				}),
			)
			.subscribe((url) => {
				if (
					url &&
					(this._lastUrlCount === -1 ||
						(url && this._history[this._lastUrlCount] !== url))
				) {
					if (this._lastUrlCount > -1) {
						this._lastUrl = this._history[this._lastUrlCount];
					}

					const nextNumber = this._lastUrlCount + 1;
					this._history[nextNumber] = url;
					this._lastUrlCount = nextNumber;
				}
			});
	}

	GoBack() {
		if (this._lastUrl) {
			const lastUrl = this._lastUrl;

			this._history[this._lastUrlCount] = undefined;

			if (this._lastUrlCount > 1) {
				this._history[this._lastUrlCount - 1] = undefined;
			}

			this._lastUrlCount = this._lastUrlCount - 2;
			this.store.dispatch(new Navigate([lastUrl]));
		}
	}

	get LastUrl$() {
		return this._lastUrl;
	}
}
